import { useMemo } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
// @mui
import { Box, Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
//
import useNavConfig from './navbar/NavConfig';

// ----------------------------------------------------------------------

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const navConfig = useNavConfig();

  // Flatten role-filtered sections into a single list of destinations.
  const items = useMemo(() => navConfig.flatMap((group) => group.items), [navConfig]);

  const currentIndex = items.findIndex(
    (item) => !!matchPath({ path: item.path, end: false }, pathname)
  );

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.appBar + 2,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        display: { lg: 'none' },
      }}
    >
      <BottomNavigation
        showLabels
        value={currentIndex === -1 ? 0 : currentIndex}
        onChange={(event, newValue) => {
          const item = items[newValue];
          if (item) navigate(item.path);
        }}
      >
        {items.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.title}
            icon={<Box sx={{ width: 24, height: 24 }}>{item.icon}</Box>}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
